import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "16",
  viewBox: "0 0 25 16",
  fill: "none",
  class: "jl2-custom-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.36078 2.06016C0.910781 2.06016 0.550781 1.63016 0.550781 1.11016C0.550781 0.590157 0.910781 0.160156 1.36078 0.160156H23.5008C23.9508 0.160156 24.3108 0.590157 24.3108 1.11016C24.3108 1.63016 23.9508 2.06016 23.5008 2.06016H1.36078Z",
      fill: "currentColor",
      class: "content"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.36078 8.60996C0.910781 8.60996 0.550781 8.17996 0.550781 7.65996C0.550781 7.13996 0.910781 6.70996 1.36078 6.70996H23.5008C23.9508 6.70996 24.3108 7.13996 24.3108 7.65996C24.3108 8.17996 23.9508 8.60996 23.5008 8.60996H1.36078Z",
      fill: "currentColor",
      class: "content"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.36078 15.1603C0.910781 15.1603 0.550781 14.7303 0.550781 14.2103C0.550781 13.6903 0.910781 13.2603 1.36078 13.2603H23.5008C23.9508 13.2603 24.3108 13.6903 24.3108 14.2103C24.3108 14.7303 23.9508 15.1603 23.5008 15.1603H1.36078Z",
      fill: "currentColor",
      class: "content"
    }, null, -1)
  ])))
}